import { Box } from "@mui/material";

export default function CustomLetterbox({ letterboxWidth, letterboxHeight, letterboxAlignVertical, letterboxAlignHorizontal, letterboxOutputResolution }) {
   // Parse output resolution
   if (!letterboxOutputResolution) {
      return null;
   }
   const [outputWidth, outputHeight] = letterboxOutputResolution.split('x').map(Number);
   
   // Calculate letterbox position based on alignment
   let letterboxX = 0;
   let letterboxY = 0;
   
   if (letterboxAlignHorizontal === "center") {
      letterboxX = (outputWidth - letterboxWidth) / 2;
   } else if (letterboxAlignHorizontal === "right") {
      letterboxX = outputWidth - letterboxWidth;
   }
   
   if (letterboxAlignVertical === "center") {
      letterboxY = (outputHeight - letterboxHeight) / 2;
   } else if (letterboxAlignVertical === "bottom") {
      letterboxY = outputHeight - letterboxHeight;
   }
   
   return (
      <>
         {/* Red solid letterbox border */}
         <Box
            sx={{
               position: "absolute",
               left: `${(letterboxX / outputWidth) * 100}%`,
               top: `${(letterboxY / outputHeight) * 100}%`,
               width: `${(letterboxWidth / outputWidth) * 100}%`,
               height: `${(letterboxHeight / outputHeight) * 100}%`,
               backgroundColor: "#000080",
               border: "1px solid #ffffff",
               boxShadow: "inset 0 0 0 4px #ff0000",
               boxSizing: "border-box",
               zIndex: 1000,
            }}
         />
         
         {/* Red label with white text showing X, Y, Width, Height */}
         <Box
            sx={{
               position: "absolute",
               left: `${(letterboxX / outputWidth) * 100}%`,
               top: `${(letterboxY / outputHeight) * 100}%`,
               backgroundColor: "#ff0000",
               color: "#ffffff",
               padding: "4px 8px",
               fontSize: "42px",
               fontFamily: "monospace",
               zIndex: 1100,
               whiteSpace: "nowrap",
            }}
         >
            X: {Math.round(letterboxX)}, Y: {Math.round(letterboxY)}, W: {letterboxWidth}, H: {letterboxHeight}
         </Box>
      </>
   );
}
